import DiscountCoupon from "@/components/DiscountCoupon/index.vue";

export default {
  name: "index",

  components: {
    DiscountCoupon,
  },

  data() {
    return {
      dcData: [
        {
          des: "满500元可使用",
          price: 30,
        },
        {
          des: "满10000元可使用",
          price: 4000,
        },
        {
          des: "满200000元可使用",
          price: 3000,
        },
      ],
    };
  },
};
